import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo } from "react";
import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { BotContext } from "../context";
import { WidgetHeader } from "../widget";
const useStyles = createUseStyles((theme) => ({
  invalid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    background: theme.invalidTokenContainerBg,
    borderRadius: 10,
    position: 'relative'
  },
  text: {
    color: "white",
    background: theme.invalidTokenBg,
    padding: [10, 20],
    borderRadius: 5,
  },
  closeBtn: {
    marginLeft: 10,
    cursor: "pointer",
    color: "white",
    position: 'absolute',
    left: 13,
    top: 16
  },
}));
const InvalidTokenWidget = memo(({ showChat, setShowChat }) => {
  const styles = useStyles();
  const { config } = useContext(BotContext)
  return (
    <div className={styles.invalid}>
      <FontAwesomeIcon
        className={styles.closeBtn}
        icon={faTimes}
        onClick={() => {
          setShowChat(false);
          // setSelectedRoom(undefined);
          // setChatsArray(undefined);
          // setChats(undefined);
          // setPage(1);
        }}
        alt="بستن"
        size="lg"
      />
      <div className={styles.text}>{config.inValidTokenMessage}</div>
    </div>
  );
});

export default InvalidTokenWidget;
